import { deploymentId } from '../../deploymentId.json';

export const IMAGE_PATH_ROOT_ALL_LOCAL = '/images/all/images' as const;
export const IMAGE_PATH_ROOT_PC_LOCAL = '/images/pc/images' as const;
export const IMAGE_PATH_ROOT_SP_LOCAL = '/images/sp/images' as const;

export const IMAGE_PATH_ROOT_ALL_REMOTE = `https://s.yimg.jp/images/news-web/versions/${encodeURIComponent(
  deploymentId
)}/all/images` as const;
export const IMAGE_PATH_ROOT_PC_REMOTE = `https://s.yimg.jp/images/news-web/versions/${encodeURIComponent(
  deploymentId
)}/pc/images` as const;
export const IMAGE_PATH_ROOT_SP_REMOTE = `https://s.yimg.jp/images/news-web/versions/${encodeURIComponent(
  deploymentId
)}/sp/images` as const;

export const IMAGE_PATH_ROOT_ALL = process.env.ASSETS_FROM_LOCAL
  ? IMAGE_PATH_ROOT_ALL_LOCAL
  : IMAGE_PATH_ROOT_ALL_REMOTE;

export const IMAGE_PATH_ROOT_PC = process.env.ASSETS_FROM_LOCAL ? IMAGE_PATH_ROOT_PC_LOCAL : IMAGE_PATH_ROOT_PC_REMOTE;

export const IMAGE_PATH_ROOT_SP = process.env.ASSETS_FROM_LOCAL ? IMAGE_PATH_ROOT_SP_LOCAL : IMAGE_PATH_ROOT_SP_REMOTE;
